import React from "react";
import Hero from "../components/Hero";
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";
// import Popup from "../components/Popup";

export default function Home() {
  return (
    <main>
      {/* <Popup /> */}
      <div className="block">
        <Navbar />
        <Hero />
        <Footer />
      </div>
    </main>
  );
}
